import BadIcon from 'assets/bad.svg'
import GoodIcon from 'assets/good.svg'
import { Banner } from 'component/Banner/Banner'
import { Image } from 'component/Image'
import { Space } from 'component/Space'
import { Gap } from 'component/Space/Gap'
import { Typo } from 'component/Typo'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { Padding } from 'util/style'

const bad1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-bad-1-9120.jpg'
const bad2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-bad-2-313e.jpg'
const bad3 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-bad-3-7846.jpg'
const good1 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-good-1-a251.jpg'
const good2 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-good-2-1cb5.jpg'
const good3 = 'https://dresscode-prod-2.s3.eu-central-1.amazonaws.com/tryon/photo-example-good-3-c513.jpg'

export const SelfieHelpStep = observer(() => {
  const font = opt.tsum ? 15 : 13
  const pad: Padding = opt.tsum ? [2, 0] : 0

  const onCancel = useLatestCallback(async () => {
    store.profile.step = 'profile'
  })

  const onProfile = useLatestCallback(() => {
    store.profile.step = 'profile'
  })

  return <Banner title={i18n('Instruction')} onCancel={onCancel}>
    <Typo size={font} secondary>
      {i18n('ProfileInstructionDescription')}
    </Typo>
    <Gap height={24} />
    <Space gap={8} top>
      <Space pad={pad}>
        <GoodIcon width={16} height={16} />
      </Space>
      <Typo size={font} medium>
        {i18n('ProfileGoodWay')}
      </Typo>
    </Space>
    <Gap height={12} />
    <Space gap={16}>
      <Image src={good1} round />
      <Image src={good2} round />
      <Image src={good3} round />
    </Space>
    <Gap height={24} />
    <Space gap={8} top>
      <Space pad={pad}>
        <BadIcon width={16} height={16} />
      </Space>
      <Typo size={font} medium>
        {i18n('ProfileBadWay')}
      </Typo>
    </Space>
    <Gap height={12} />
    <Space gap={16}>
      <Image src={bad1} />
      <Image src={bad2} />
      <Image src={bad3} />
    </Space>
  </Banner>
})
